// ----------------------------------------------------------------------

const shape = {
  borderRadius: 5,
  borderRadiusSm: 6,
  borderRadiusMd: 8
};

export default shape;
